import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject, replaceLastPoint } from "../shared";
export function calculateModifiedSchiffGeometry(drawing, scales) {
    const [pivotPoint, leftPoint, rightPoint] = drawing.points;
    if (!pivotPoint || !leftPoint || !rightPoint)
        return null;
    const pivot = chartPointToPixel(pivotPoint, scales);
    const leftSwing = chartPointToPixel(leftPoint, scales);
    const rightSwing = chartPointToPixel(rightPoint, scales);
    // Modified Schiff offset: 25% of P0-P1 distance
    const offsetX = (leftSwing.x - pivot.x) * 0.25;
    const offsetY = (leftSwing.y - pivot.y) * 0.25;
    const shiftedPivot = {
        x: pivot.x + offsetX,
        y: pivot.y + offsetY,
    };
    const midpoint = {
        x: (leftSwing.x + rightSwing.x) / 2,
        y: (leftSwing.y + rightSwing.y) / 2,
    };
    const direction = {
        x: midpoint.x - shiftedPivot.x,
        y: midpoint.y - shiftedPivot.y,
    };
    const extend = 10000;
    const medianEnd = {
        x: shiftedPivot.x + direction.x * extend,
        y: shiftedPivot.y + direction.y * extend,
    };
    const upperEnd = {
        x: leftSwing.x + direction.x * extend,
        y: leftSwing.y + direction.y * extend,
    };
    const lowerEnd = {
        x: rightSwing.x + direction.x * extend,
        y: rightSwing.y + direction.y * extend,
    };
    return {
        pivot: shiftedPivot,
        leftSwing,
        rightSwing,
        medianLine: { start: shiftedPivot, end: medianEnd },
        upperLine: { start: leftSwing, end: upperEnd },
        lowerLine: { start: rightSwing, end: lowerEnd },
    };
}
const ModifiedSchiff = {
    name: "modifiedSchiff",
    createDraft: (startPoint) => createDrawingObject("modifiedSchiff", [startPoint, startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default ModifiedSchiff;
